import {
  FindReasons,
  ReasonFilters,
  ReasonsList,
} from 'components/Pages/CancelationReasons';
import { ListingPageHeader, Paginator, SettingsMenu } from 'components/Shared';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateCancelationReasonsActions as PaginateActions } from 'store/ducks/cancelationReasons';
import * as S from './styles';

export const CancelationReasonsListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('cancelationReasons');

  const {
    data: reasons,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateCancelationReasons);

  const [query, setQuery] = useState<FindReasons>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.CancelationIcon />}
          title="Justificativas de cancelamento"
          isLoading={loading}
          actions={
            <S.LinkButton
              to={'/configuracoes/justificativas-cancelamento/criar'}
              size="small"
            >
              <S.PlusIcon /> Nova justificativa
            </S.LinkButton>
          }
        />
        <ReasonFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <ReasonsList
          reasons={reasons}
          currentSort={query}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
